import { type ApplicationConfig, provideZoneChangeDetection, inject, provideAppInitializer, isDevMode } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { apiHeadersInterceptor } from './core/interceptors/api-headers.interceptor';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { environment } from 'src/environments/environment';
// import { getApp, initializeApp, provideFirebaseApp } from '@angular/fire/app';
// import { browserPopupRedirectResolver, indexedDBLocalPersistence, browserSessionPersistence, connectAuthEmulator, getAuth, provideAuth, initializeAuth, Auth, setPersistence, browserLocalPersistence, inMemoryPersistence } from '@angular/fire/auth';
// import { connectFirestoreEmulator, initializeFirestore, provideFirestore } from '@angular/fire/firestore';
// import { connectStorageEmulator, getStorage, provideStorage } from '@angular/fire/storage';
// import { provideAuth0 } from '@auth0/auth0-angular';
import { MyPreset } from './app.theme';
import { providePrimeNG } from 'primeng/config';
import { LayoutService } from './core/layout.service';
import { SessionService } from './core/session.service';
import { SupabaseService } from './core/supabase.service';
import { provideServiceWorker } from '@angular/service-worker';
import { provideMarkdown, MERMAID_OPTIONS } from 'ngx-markdown';


const useEmulators = false;
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withRouterConfig({paramsInheritanceStrategy: 'always'}),
      // withComponentInputBinding(),
    ),
    provideHttpClient(
      withInterceptors([apiHeadersInterceptor])
    ),
    provideMarkdown({
      mermaidOptions: {
        provide: MERMAID_OPTIONS,
        useValue: {
          theme: 'dark',
        },
      },
    }),
    provideAnimationsAsync(),
    // provideAuth0({
    //   domain: 'northai-dev.us.auth0.com',
    //   clientId: '6h8vHZbrNX560Yfc0HRsQV8DGt2xkDI7', // Replace with your Frontend Client ID
    //   useRefreshTokens: true,
    //   cacheLocation: 'localstorage',
    //   authorizationParams: {
    //     redirect_uri: window.location.origin + '/callback',
        
    //     // ⚠️ CRITICAL: Must match your backend "Audience"
    //     audience: 'https://api.northai.io',
        
    //     // The permissions your frontend asks for
    //     scope: 'openid profile email read:data write:data offline_access'
    //   }
    // }),
    // provideFirebaseApp(() => initializeApp(environment.firebase)),
    // provideAuth(() => {
    //   const auth = initializeAuth(getApp(), {
    //       persistence: useEmulators
    //         ? browserSessionPersistence
    //         : indexedDBLocalPersistence,
    //       popupRedirectResolver: browserPopupRedirectResolver
    //   });
    //   if (useEmulators) {
    //     connectAuthEmulator(auth, `http://localhost:9099`, { disableWarnings: true });
    //   }
    //   // Set up persistence fallback chain asynchronously
    //   // setPersistence(auth, indexedDBLocalPersistence).catch(() => {
    //   //   setPersistence(auth, browserLocalPersistence).catch(() => {
    //   //     setPersistence(auth, browserSessionPersistence).catch(() => {
    //   //       setPersistence(auth, inMemoryPersistence).catch(() => {
    //   //         // All persistence methods failed, but auth will still work with in-memory
    //   //         console.warn('All persistence methods failed, using in-memory persistence');
    //   //       });
    //   //     });
    //   //   });
    //   // });
    //   return auth;
    // }),
    // provideFirestore(() => {
    //   const firestore = initializeFirestore(getApp(), {
    //     experimentalForceLongPolling: useEmulators ? true : false
    //   });
    //   if (useEmulators) {
    //     connectFirestoreEmulator(firestore, 'localhost', 8081)
    //   }
    //   return firestore;
    // }),
    // provideStorage(() => {
    //   const storage = getStorage();
    //   if (useEmulators) {
    //     connectStorageEmulator(storage, 'localhost', 9199);
    //   }
    //   return storage;
    // }),
    providePrimeNG({
      ripple: true,
      inputStyle: 'filled',
      theme: {
        preset: MyPreset,
        // preset: Aura,
        options: {
          darkModeSelector: '.dark',
        }
      }
    }),
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: (
    //     layout: LayoutService,
    //     auth: AuthService,
    //     ss: SessionService,
    //     ass: AssignmentService,
    //     bs: BillingService,
    //   ) => async () => {
    //     // loading.loadingOn();
    //     await layout.appInit();
    //     await auth.appInit();
    //     await ss.appInit();
    //     await ass.appInit();
    //     await bs.appInit(); // must be after auth and ss
    //   },
    //   multi: true,
    //   deps: [
    //     LayoutService,
    //     AuthService,
    //     SessionService,
    //     AssignmentService,
    //     BillingService,
    //   ]
    // },
    provideAppInitializer(() => {
      const initializerFn = ((
        // firebaseAuth: Auth, 
        layout: LayoutService,
        supabase: SupabaseService,
        session: SessionService
      ) => async () => {
        // await ss.appInit(firebaseAuth);
        await layout.appInit();
        await supabase.appInit();
        await session.appInit();
        }
      )(
        // inject(Auth), 
        inject(LayoutService), 
        inject(SupabaseService),
        inject(SessionService)
      );
        return initializerFn();
      }), 
      provideServiceWorker('ngsw-worker.js', {
          // enabled: !isDevMode(),
          registrationStrategy: 'registerWhenStable:30000'
      }), 
  ],
};
